import {
  detectLangFromPath,
  stripLangFromPath,
  SUPPORTED_LANGS,
} from "./detectLangFromPath";

const DEFAULT_LOCALE = "it";
export const LOCALE_STORAGE_KEY = "__extraconomy_locale";

let redirectPending = false;

function isSupportedLocale(lang) {
  return Boolean(lang && SUPPORTED_LANGS.includes(lang));
}

function getStoredLocale() {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  return isSupportedLocale(stored) ? stored : null;
}

/**
 * Idioma ativo: preferência do usuário > prefixo da URL > fallback.
 */
export function getLocale() {
  return getStoredLocale() || detectLangFromPath() || DEFAULT_LOCALE;
}

export function setUserLocale(lang) {
  if (!isSupportedLocale(lang)) return getLocale();
  localStorage.setItem(LOCALE_STORAGE_KEY, lang);
  return lang;
}

export function isLocaleRedirectPending() {
  return redirectPending;
}

export function buildLocalizedUrl(lang, location = window.location) {
  const pathWithoutLang = stripLangFromPath(location.pathname);
  const normalizedPath = pathWithoutLang === "/" ? "" : pathWithoutLang;
  return `/${lang}${normalizedPath}${location.search}${location.hash}`;
}

export function ensureUrlMatchesPreference() {
  const preferred = getStoredLocale();
  if (!preferred) {
    return false;
  }

  const urlLang = detectLangFromPath();
  if (urlLang === preferred) {
    return false;
  }

  redirectPending = true;
  window.location.replace(buildLocalizedUrl(preferred));
  return true;
}

export const locale = getLocale();
